export default {
  course_title: '02Web-智门户课程',
  course_title_list: "0201Web-显示课程列表",
  course_watch_course: "0202Web-查看课程",
  course_category: '课程分类',
  course_new: '按最新',
  course_hot: '按最热'
}
